export default __webpack_public_path__ + "static/media/phone_number.cbc15f97.svg";